import localStorageAvailable from "../../utils/localStorageAvailable";
import axios from "../../utils/axios";
import { enqueueSnackbar } from "notistack";

const getStaff = async (
  vendor,
  user,
  search,
  logout,
  page,
  roles,
  pageSize,
  vendor_id
) => {
  const storageAvailable = localStorageAvailable();
  const accessToken = storageAvailable
    ? localStorage.getItem("accessToken")
    : "";

  const config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `/service/accounts_service/v1/staff/${vendor}`,
    headers: {
      authorization: `Bearer ${accessToken}`,
      user,
    },
    params: { search, page, page_size: pageSize, vendor_id },
  };
  if (roles) {
    config.params.roles = roles;
  }
  try {
    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    if (error?.data === "Verification timeout") {
      return;
    }
    if (error?.status === 401) {
      enqueueSnackbar("Un Authorized Request", {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      logout();
    }
    enqueueSnackbar(error?.data, {
      variant: "error",
      anchorOrigin: {
        vertical: "top",
        horizontal: "right",
      },
    });
  }
};

export default getStaff;
